export enum EthereumNetwork {
    /** Avalanche C-chain */
    Avalanche = 'avalanche',
    /** Binance Smart Chain Mainnet */
    Bsc = 'bsc',
    /** Celo Mainnet */
    CeloMainnet = 'celo_mainnet',
    /** Cronos Mainnet */
    Cronos = 'cronos',
    /** Ethereum Classic */
    Ethclassic = 'ethclassic',
    /** Ethereum Classic ( no reorg from block 10904146) */
    EthclassicReorg = 'ethclassic_reorg',
    /** Ethereum Mainnet */
    Ethereum = 'ethereum',
    /** Ethereum PoW */
    Ethpow = 'ethpow',
    /** Fantom Mainnet */
    Fantom = 'fantom',
    /** Klaytn Mainnet */
    Klaytn = 'klaytn',
    /** Matic (Polygon) Mainnet */
    Matic = 'matic',
    /** Moonbeam Mainnet */
    Moonbeam = 'moonbeam',
    /** Velas Mainnet */
    Velas = 'velas',
}
